import * as types from '../constants/ActionTypes'

const registernotifier = (state = [], action) => {
    switch (action.type) {
      case types.LIST_NOTIFIER:
            return action.notifiers.map(notifier => {
                  return notifier
            })
      case types.ADD_NOTIFIER:
                    return [
                      {
                        idnotifier: action.id,
                        description: action.description,
                        data: action.data, 
                        display: action.display,
                        author: action.author,
                        mensagem: action.mensagem,
                        task: action.task,
                        remote: action.remote,
                        ingdesk_data: action.ingdesk_data
                      }, 
                      ...state,
                    ]            
      case types.DELETE_NOTIFIER:
          return state.map(notifier => {
            if(parseInt(notifier.idnotifier) === parseInt(action.idnotifier)){ 
              return { ...notifier, 
                task: '2',
              }
            }
              return notifier
          })
      case types.DELETE_NOT_REMOTE:
          return state.map(notifier => {
            if(parseInt(notifier.remote) === parseInt(action.remote)){ 
              return { ...notifier, 
                task: '2',
              }
            }
              return notifier
          })
      default:
            return state
    }
  }
  
  export default registernotifier